// Imports
import ReactDOM from 'react-dom/client';
import App from './app';
import ErrorBoundary from './error-boundary';


// Create root
const container = document.getElementById('root');

if (!container) {
	throw new Error('Root container should exist');
}

const root = ReactDOM.createRoot(container);


// Mount & render
root.render(
	<ErrorBoundary>
		<App />
	</ErrorBoundary>
);
